import React from 'react';
import {View, Text, StyleSheet} from 'react-native';
import i18n from 'i18n-js';
import {fontFamily} from '../../helpers/fontFamily';

const ICONS = {
  empty: 'icon-empty',
  occupied: 'icon-occupied',
  collect: 'icon-completed',
  complete: 'icon-flag-checkered'
};

const CAPTIONS = {
  empty: 'productFirst.stateEmpty',
  occupied: 'productFirst.stateOccupied',
  collect: 'productFirst.stateCollect'
};

const ToteBanner = ({state, toteIdentifier, toteName, message}) => {
  if (state === 'complete') {
    return (
      <View style={[styles.banner, styles.completeBanner]}>
        <i className={ICONS.complete} style={{fontSize: 56, color: '#000'}} />
        <View style={styles.completeTextWrap}>
          <Text style={styles.completeText}>
            {i18n.t('productFirst.orderComplete')}
          </Text>
          {message ? <Text style={styles.caption}>{message}</Text> : null}
        </View>
      </View>
    );
  }

  const subtitleKey =
    state === 'occupied'
      ? 'productFirst.bannerPlaceOccupied'
      : state === 'empty'
      ? 'productFirst.bannerPlaceEmpty'
      : null;
  const mainKey =
    state === 'collect' ? 'productFirst.bannerCollect' : 'productFirst.bannerScan';

  return (
    <View style={styles.banner}>
      {subtitleKey && (
        <Text style={styles.subtitle}>
          {i18n.t(subtitleKey, {toteIdentifier, toteName})}
        </Text>
      )}
      <Text style={styles.message}>
        {i18n.t(mainKey, {toteIdentifier, toteName})}
      </Text>
      <View style={styles.iconGroup}>
        <i
          className={ICONS[state]}
          style={{
            fontSize: 46,
            color: '#000',
            lineHeight: 1,
            display: 'block',
            width: 140,
            textAlign: 'center',
            transform: 'translateX(-14px)'
          }}
        />
        <Text style={[styles.caption, {width: 140}]}>
          {i18n.t(CAPTIONS[state])}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  banner: {
    backgroundColor: '#e6e600',
    paddingVertical: 18,
    paddingHorizontal: 16,
    alignItems: 'center'
  },
  iconGroup: {
    alignItems: 'center',
    marginTop: 12
  },
  completeBanner: {
    flexDirection: 'row',
    justifyContent: 'center'
  },
  completeTextWrap: {
    marginLeft: 16,
    flexShrink: 1
  },
  subtitle: {
    color: '#000',
    fontSize: 15,
    fontFamily: fontFamily.font400,
    textAlign: 'center',
    marginBottom: 8
  },
  message: {
    color: '#000',
    fontSize: 24,
    fontFamily: fontFamily.font700,
    textAlign: 'center'
  },
  caption: {
    color: '#000',
    fontSize: 14,
    fontFamily: fontFamily.font400,
    textAlign: 'center',
    marginTop: 6
  },
  completeText: {
    color: '#000',
    fontSize: 30,
    fontFamily: fontFamily.font700
  }
});

export default ToteBanner;
